import React, { FormEvent } from 'react'
import liveSearchConfig from '../config/liveSearchConfig'
import useOutsideClick from 'src/hooks/useOutsideClick'
import { useSearch } from '../state/useSearch'
import SearchTabs from './SearchTabs'
import SearchForm from './SearchForm'
import StaticSearchResults from './results/StaticSearchResults'
import { debounce } from 'lodash'
import staticSearchConfig from '../config/staticSearchConfig'
import SearchPagination from './SearchPagination'
import determineTypeFilters from '../utils/helpers/determineTypeFilters'
import { useRouter } from 'next/router'
import TabOptions from '../types/enums/TabOptions'

export const StaticSearch: React.FC = () => {
    const searchBoxRef = React.useRef()
    const {
        activeTab,
        getResults,
        setSearchTerm,
        setShowResults,
        setCurrentPage,
        setNextToken,
        setIsSearching,
        searchTerm,
        setActiveTab,
    } = useSearch()
    const router = useRouter()

    React.useEffect(() => {
        handleSearchType()
        handleSearchTerms()
    }, [router?.isReady])

    React.useEffect(() => {
        setCurrentPage(1)
        setNextToken('')
        if (searchTerm) debouncedSearch()
    }, [activeTab])

    useOutsideClick(
        searchBoxRef,
        React.useCallback(() => {
            setShowResults(false)
        }, [])
    )

    const handleSearchTerms = () => {
        if (router.isReady && router?.query?.searchTerm) {
            setSearchTerm(String(router?.query?.searchTerm))
            const searchInitialTerm = setTimeout(() => {
                debouncedSearch()
            }, 300)

            return () => clearTimeout(searchInitialTerm)
        } else {
            setIsSearching(false)
        }
    }

    const handleSearchType = () => {
        if (router.isReady && router?.query?.type) {
            Object.entries(TabOptions).forEach((option, i) => {
                if (router?.query?.type === option[1]) {
                    setActiveTab(TabOptions[option[0]])
                }
            })
        }
    }

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        setCurrentPage(1)
        setNextToken('')
        debouncedSearch()
    }
    const debouncedSearch = React.useMemo(
        () =>
            debounce(async () => {
                await getResults({
                    limit: staticSearchConfig.limit,
                    nextToken: '',
                    search: {
                        typeFilters: determineTypeFilters(activeTab),
                    },
                })
            }, 200),
        [activeTab]
    )

    return (
        <div className='relative h-auto w-full bg-white' ref={searchBoxRef}>
            <div className=''>
                <SearchForm
                    config={liveSearchConfig}
                    onSubmit={handleSubmit}
                    customClasses='border-gray-100 border-px rounded-md mt-6'
                />
                {liveSearchConfig.tabs && <SearchTabs />}
                <StaticSearchResults />
                <SearchPagination />
            </div>
        </div>
    )
}

export default StaticSearch
